import Request from './request'

const Task = {
  getTasks (page, callback) {
    Request.get('device-task/' + page).then(callback).catch(this.bad_answer)
  },
  getDeviceTask (id, callback) {
    Request.get('device-task/device/' + id).then(callback).catch(this.bad_answer)
  },
}
export default Task
